import { useCallback, useEffect, useRef, useState } from 'react';

const ACTIVITY_EVENTS: Array<keyof WindowEventMap> = [
  'pointerdown',
  'pointermove',
  'touchstart',
  'keydown',
  'wheel',
];

/**
 * Figyeli a felhasználói interakciót, és `timeoutMs` inaktivitás után `isIdle = true`-ra vált.
 * Bármilyen érintés/kattintás/gombnyomás visszaállítja az időzítőt.
 */
export function useIdleTimer(timeoutMs: number) {
  const [isIdle, setIsIdle] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const reset = useCallback(() => {
    setIsIdle(false);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => setIsIdle(true), timeoutMs);
  }, [timeoutMs]);

  useEffect(() => {
    reset();
    ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, reset, { passive: true }));
    return () => {
      ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, reset));
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [reset]);

  return { isIdle, resetIdleTimer: reset };
}
